import { render, staticRenderFns } from "./EnrollButton.vue?vue&type=template&id=eefdaf22&scoped=true&"
import script from "./EnrollButton.vue?vue&type=script&lang=ts&"
export * from "./EnrollButton.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollButton.vue?vue&type=style&index=0&id=eefdaf22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefdaf22",
  null
  
)

export default component.exports